/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TableMessagesReceived_EmbedQuery = {
    readonly messagesReceived: ReadonlyArray<{
        readonly _id: string;
        readonly " $fragmentRefs": FragmentRefs<"TableRowMessage_EmbedMessage">;
    } | null> | null;
    readonly " $refType": "TableMessagesReceived_EmbedQuery";
};
export type TableMessagesReceived_EmbedQuery$data = TableMessagesReceived_EmbedQuery;
export type TableMessagesReceived_EmbedQuery$key = {
    readonly " $data"?: TableMessagesReceived_EmbedQuery$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TableMessagesReceived_EmbedQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdAtFrom"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdAtTo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TableMessagesReceived_EmbedQuery",
  "selections": [
    {
      "alias": "messagesReceived",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "gte",
                      "variableName": "createdAtFrom"
                    },
                    {
                      "kind": "Variable",
                      "name": "lte",
                      "variableName": "createdAtTo"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "createdAt"
                },
                {
                  "kind": "Literal",
                  "name": "status",
                  "value": {
                    "ne": "skipped"
                  }
                }
              ],
              "kind": "ObjectValue",
              "name": "_operators"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "inbound"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "limit",
          "value": 5
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": "_ID_DESC"
        }
      ],
      "concreteType": "Message",
      "kind": "LinkedField",
      "name": "messageMany",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "_id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TableRowMessage_EmbedMessage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '3867104cd708ecf925e375e38a31f624';
export default node;
